import React, { useState, useMemo, useRef, useEffect } from 'react';
import { FormGroup, Modal, Row, Col } from 'react-bootstrap';
import { cloneDeep, isArray, concat, last, isEmpty, flatMap } from 'lodash';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { MentionsInput, Mention } from 'react-mentions';
import Loader from '../../../../../../Components/Utility/Loader/Loader';
import {
  productListLocationsArray,
  calculationProductListSubLocationsArray,
  checValidMongoId,
  calculationBtnArrays,
  splitAndFilterString,
  handleSubLocation,
  RightsAccess,
  customStyles,
} from '../../../../../../Components/helper';
import { toasterMsg } from '../../../../../../Components/Toaster/Toaster';
import { useCustomModuleState } from '../../../Context/index';
import * as rangePlaneAction from '../../../../../RangePlan/CustomSections/store/CustomSections.action';
import * as action from '../../../Store/CustomModule.action';
import { ClearIcon, CloseIcon, EditIcon, RedoIcon, SaveIcon, SearchIcon, TickIcon, UndoIcon } from '../../../../../../bombiix-icon';
import { NewInput } from '../../../../../../Components/PIM/common/NewInput';
import { NewTextArea } from '../../../../../../Components/PIM/common/NewTextArea';

export default function CalculationComponent({
  pageIndex,
  setIsCalculation,
  setIsEditCalculation,
  showEdit,
  gridIndex,
  index,
  deleteItem,
  onChange,
  setDroppedIndex,
}) {
  const productCoreInformation = 'Product Core Information';
  const { moduleLibId } = useParams();
  const locationRef = useRef(null);
  const subLocationRef = useRef(null);
  const pageRef = useRef(null);
  const controlRef = useRef(null);
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const {
    customSectionData: { dynamicColArr, measurementArr, sampleTrackingDates, currSectionList },
    CustomModuleReducer: { customLibraryDetail, customLibraryCalculationList, customLibraryPagesCalculationList, customLibraryPageControlsCalculationList },
  } = useSelector((reducer) => reducer);
  const { rangePlanRight, TestingRight } = RightsAccess();
  const { customModuleState, setCustomModuleState } = useCustomModuleState();
  const [hideCustomModule, setHideCustomModule] = useState(false);
  const [state, setState] = useState({
    name: '',
    mainLoader: false,
    formulaArray: [],
    currLocation: {
      label: productCoreInformation,
      name: 'Product_Core_Information',
      _id: 11,
    },
    currSubLocation: null,
    currPage: null,
    currControl: null,
    counter: 0,
    locationArray: productListLocationsArray,
    filteredLocationArray: productListLocationsArray,
    filteredSubLocationArray: [],
    subLocationArray: [],
    filteredPageArray: [],
    pageArray: [],
    controlsArray: [],
    filteredControlsArray: [],
    formulaString: '',
    readOnlyFormulaString: '',
    hasError: false,
    currentColumn: null,
    currentRow: -1,
    bracketCounter: 0,
  });
  const [undo, setUndo] = useState([]);
  const [redo, setRedo] = useState([]);
  const [allowEditFormula, setAllowEditFormula] = useState(false);
  const [rootAtLast, setRootAtLast] = useState(false);
  const [formulaHasError, setFormulaHasError] = useState(false);
  const [childOptions, setChildOptions] = useState([]);

  const customLibraryCase = (val) => {
    return val?.control?.type === 'Table' ? state?.currentColumn?.type === 'string' : val?.control?.type === 'string';
  };

  const foundString = state?.formulaArray?.filter((val) => {
    return val?.location?.name === 'Custom_Modules' ? customLibraryCase(val) : val?.subLocation?.type === 'string';
  });
  const checkFormulaHasStringType = foundString?.length > 0;
  const counterState = state?.counter === 0;
  useEffect(() => {
    if (!TestingRight) {
      const updatedData = productListLocationsArray.filter((item) => item.name !== 'Testing_Information');
      setState((prev) => ({
        ...prev,
        locationArray: updatedData,
        filteredLocationArray: updatedData,
      }));
    }
  }, [productListLocationsArray, TestingRight]);

  useEffect(() => {
    setCustomModuleState((prevState) => ({ ...prevState, disableDrag: true }));
  }, []);

  useEffect(() => {
    if (state?.locationArray?.length > 0) {
      const opArray = [];
      state?.locationArray?.forEach((val) => {
        if (val.name !== 'Custom_Modules') {
          const getSectionsColumns = cloneDeep(currSectionList?.find((ele) => val?.name === ele?._id));
          const locationValue = cloneDeep(calculationProductListSubLocationsArray?.find((subLocationArr) => val?._id === subLocationArr?.locationId));
          if (locationValue) {
            locationValue?.subLocations?.forEach((subEle) => {
              opArray.push({ id: `${subEle?.label}_(${val?.label})`, display: `${subEle?.label}_(${val?.label})` });
            });
          } else if (getSectionsColumns && isArray(getSectionsColumns?.columns) && getSectionsColumns?.columns.length > 0) {
            getSectionsColumns?.columns?.forEach((dyCol) => {
              opArray.push({ id: `${dyCol?.title}_(${val?.label})`, display: `${dyCol?.title}_(${val?.label})` });
            });
          }
        }
      });
      setChildOptions(opArray);
    }
  }, [state, currSectionList, calculationProductListSubLocationsArray]);

  const checkFormulaHasPercentage = () => {
    const lastObj = last(state?.formulaArray);
    return lastObj?.subLocation?.name === '%';
  };
  const checkFormulaHasRoot = () => {
    const lastObj = last(state?.formulaArray);
    return lastObj?.subLocation?.name === '√';
  };
  const checkSqAtLast = () => {
    const lastObj = last(state?.formulaArray);
    return lastObj?.subLocation?.name === 'X²';
  };

  const checkPiAtLast = () => {
    const lastObj = last(state?.formulaArray);
    return lastObj?.subLocation?.name === 'π';
  };

  const checkDisableNumbers = () => {
    const lastObj = last(state?.formulaArray);
    return ['X²', 'π', ')'].includes(lastObj?.subLocation?.name);
  };

  const checkDisableSpecials = () => {
    const lastObj = last(state?.formulaArray);
    return lastObj?.subLocation?.type === 'Number';
  };

  const checkFormulaHasPercentageAtLast = useMemo(() => {
    return {
      percentage: checkFormulaHasPercentage(),
      root: checkFormulaHasRoot(),
      disableNumbers: checkDisableNumbers(),
      disableSpecialCharacter: checkDisableSpecials(),
      squareAtLast: checkSqAtLast(),
      piAtLast: checkPiAtLast(),
      closingBreak: !state?.bracketCounter,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.formulaArray?.length]);

  const calculationBtnArr = calculationBtnArrays(
    checkFormulaHasStringType,
    counterState,
    checkFormulaHasPercentageAtLast.percentage,
    checkFormulaHasPercentageAtLast.root,
    checkFormulaHasPercentageAtLast.disableNumbers,
    checkFormulaHasPercentageAtLast.disableSpecialCharacter,
    checkFormulaHasPercentageAtLast.squareAtLast,
    checkFormulaHasPercentageAtLast.piAtLast,
    checkFormulaHasPercentageAtLast.closingBreak,
  );
  useEffect(() => {
    if (isArray(currSectionList) && currSectionList.length > 0) {
      const manipulatedSectionList = currSectionList?.map((section) => {
        return {
          label: section?.name,
          name: section?._id,
        };
      });
      setState((prev) => ({
        ...prev,
        locationArray: [...prev.locationArray, ...manipulatedSectionList],
        filteredLocationArray: [...prev.filteredLocationArray, ...manipulatedSectionList],
      }));
    }
  }, [currSectionList]);

  const handleFilter = (val, filterBy) => {
    if (filterBy === 'location') {
      const filteredData = state?.locationArray?.filter((location) => location.label.toLowerCase().includes(val.toLowerCase()));
      setState((prev) => ({
        ...prev,
        filteredLocationArray: filteredData,
      }));
    } else if (filterBy === 'subLocation') {
      const filteredData = state?.subLocationArray?.filter((subLocation) => subLocation.label.toLowerCase().includes(val.toLowerCase()));
      setState((prev) => ({
        ...prev,
        filteredSubLocationArray: filteredData,
      }));
    } else if (filterBy === 'page') {
      const filteredPage = state?.pageArray?.filter((page) => page.label.toLowerCase().includes(val.toLowerCase()));
      setState((prev) => ({
        ...prev,
        filteredPageArray: filteredPage,
      }));
    } else {
      const filteredControls = state?.controlsArray?.filter((page) => page.label.toLowerCase().includes(val.toLowerCase()));
      setState((prev) => ({
        ...prev,
        filteredControlsArray: filteredControls,
      }));
    }
  };

  useEffect(() => {
    // disable if no RP Rights
    const fetchCalculation = async () => {
      setState((prev) => ({ ...prev, mainLoader: true }));
      const res = await Promise.all([
        dispatch(rangePlaneAction.fetchAllSections()),
        dispatch(rangePlaneAction.getAllCustomAttributes()),
        dispatch(rangePlaneAction.getAllMeasurment()),
        dispatch(rangePlaneAction.getSampleTrackingDates()),
      ]);
      if (res) setState((prev) => ({ ...prev, mainLoader: false }));
    };
    if (rangePlanRight) fetchCalculation();
  }, [dispatch, rangePlanRight]);

  useEffect(() => {
    if (customModuleState?.modalEdit) {
      setUndo([...undo, ...(customModuleState?.editpopupChildData?.relation?.formulaArray || [])]);
      const hasCMTemp = customModuleState?.editpopupChildData?.relation?.formulaArray?.some((item) => {
        return item?.location?.name === 'Custom_Modules';
      });
      if (hasCMTemp) {
        setHideCustomModule(true);
      }
      setState((prevState) => ({ ...prevState, ...customModuleState?.editpopupChildData?.relation, name: customModuleState?.editpopupChildData?.label }));
    }
  }, [customModuleState?.modalEdit, customModuleState?.editpopupChildData?.label, customModuleState?.editpopupChildData?.relation]);

  useEffect(() => {
    if (customModuleState?.modalEdit) {
      const lastObj = last(state?.formulaArray);
      const obj = { counter: 0 };
      if (
        [')'].includes(lastObj?.subLocation?.name) ||
        ['number', 'Number', 'Number_percentage', 'Calculation'].includes(lastObj?.subLocation?.type) ||
        lastObj?.subLocation?.type === 'string' ||
        (lastObj?.subLocation?.type === 'symbol' && ['π', '√', ')', '%', 'X²'].includes(lastObj?.subLocation?.name))
      ) {
        obj.counter = 1;
      } else if (lastObj?.subLocation?.type === 'symbol') {
        obj.counter = 0;
      }
      setState((prev) => ({
        ...prev,
        counter: obj?.counter,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customModuleState?.modalEdit, state?.formulaArray?.length]);

  const updateFormulaString = (formulaArrays) => {
    let getCurrFormulaString = '';
    let readOnlyFormulaString = '';
    if (state?.currLocation?.name === 'Custom_Modules') {
      formulaArrays?.forEach((formula) => {
        if (['symbol', 'Number'].includes(formula?.location?.type) || formula?.location?.name !== 'Custom_Modules') {
          getCurrFormulaString = getCurrFormulaString.concat(formula?.subLocation?.name, '');
          readOnlyFormulaString = readOnlyFormulaString.concat(formula?.subLocation?.label, '');
        } else if (formula?.control?.type === 'Table') {
          getCurrFormulaString = getCurrFormulaString.concat(`${formula?.control?.name}_${formula?.column?.key}_${formula?.row?.rowIndex}`, '');
          readOnlyFormulaString = readOnlyFormulaString.concat(`${formula?.control?.label}_${formula?.column?.name}_${formula?.row?.name}`, '');
        } else {
          getCurrFormulaString = getCurrFormulaString.concat(formula?.control?.name, '');
          readOnlyFormulaString = readOnlyFormulaString.concat(formula?.control?.label, '');
        }
      });
    } else {
      formulaArrays?.forEach((formula) => {
        if (formula?.row) {
          getCurrFormulaString = getCurrFormulaString.concat(`${formula?.control?.name}_${formula?.column?.key}_${formula?.row?.rowIndex}`, '');
          readOnlyFormulaString = readOnlyFormulaString.concat(`${formula?.control?.label}_${formula?.column?.name}_${formula?.row?.name}`, '');
        } else if (formula?.control) {
          getCurrFormulaString = getCurrFormulaString.concat(formula?.control?.name, '');
          readOnlyFormulaString = readOnlyFormulaString.concat(formula?.control?.label, '');
        } else {
          getCurrFormulaString = getCurrFormulaString.concat(formula?.subLocation?.name, '');
          readOnlyFormulaString = readOnlyFormulaString.concat(formula?.subLocation?.label, '');
        }
      });
    }
    const lastObj = last(formulaArrays);
    let counter = 0;
    if (
      [')', 'X²', 'π'].includes(lastObj?.subLocation?.name) ||
      ['number', 'Number', 'Number_percentage'].includes(lastObj?.subLocation?.type) ||
      lastObj?.subLocation?.type === 'string' ||
      (lastObj?.subLocation?.type === 'symbol' && lastObj?.subLocation?.name === '%')
    ) {
      counter = 1;
    }
    setState((prev) => ({
      ...prev,
      formulaArray: formulaArrays,
      formulaString: getCurrFormulaString,
      readOnlyFormulaString,
      counter,
    }));
  };

  const hasStringValue = (clonedFormulaArray) => {
    return clonedFormulaArray
      .filter((val) => !['(', ')', '%'].includes(val?.subLocation?.name))
      .map((eleFormula) => {
        let formula = eleFormula;
        if (formula?.subLocation?.type === 'symbol') {
          formula = {
            location: { name: '&', label: '&', type: 'symbol' },
            subLocation: { name: '&', label: '&', type: 'symbol' },
          };
        }
        return formula;
      });
  };

  const createAndPushObj = (locationValue, clonedFormulaArray) => {
    const obj = {
      location: locationValue,
      subLocation: locationValue,
    };
    clonedFormulaArray.push(obj);
  };

  const onLocationChange = async (locationValue, keyName) => {
    if (rootAtLast) {
      setRootAtLast(false);
    }
    if (formulaHasError) {
      setFormulaHasError(false);
    }
    if (keyName === 'subLocation' && state?.currLocation?.name === 'Custom_Modules') {
      await dispatch(action.getCalculationPagesList(locationValue?.name));
    }
    if (keyName === 'page' && state?.currSubLocation && state?.currLocation?.name === 'Custom_Modules' && locationValue) {
      await dispatch(action.getCalculationPageControlList(state?.currSubLocation?.name, locationValue?.name));
    }
    let clonedFormulaArray = state?.formulaArray;
    if (keyName === 'name') {
      setState((prev) => ({
        ...prev,
        name: locationValue,
      }));
    } else if (keyName === 'location') {
      if (locationValue?.name === 'Custom_Modules') {
        setHideCustomModule(true);
        await dispatch(action.getAllCustomModuleForCalculations({ isAllRecord: true }));
      }
      setState((prev) => ({
        ...prev,
        counter: 0,
        currSubLocation: null,
        currControl: null,
        currentColumn: null,
        currentRow: -1,
        currPage: null,
        currLocation: locationValue,
      }));
    } else if (keyName === 'currentColumn') {
      setState((prev) => ({ ...prev, currentColumn: locationValue, currentRow: -1 }));
    } else if (keyName === 'currentRow') {
      const obj = {
        location: state?.currLocation,
        subLocation: state?.currSubLocation,
        page: state?.currPage,
        control: state?.currControl,
        column: state?.currentColumn,
        row: locationValue,
      };
      clonedFormulaArray = concat(clonedFormulaArray, obj);
      setState((prev) => ({ ...prev, currentRow: locationValue, counter: 1 }));
    } else if (keyName === 'control' && state?.currLocation?.name === 'Custom_Modules' && locationValue?.type === 'Table') {
      setState((prev) => ({ ...prev, currControl: locationValue, currentColumn: null, currentRow: -1 }));
    } else if (keyName === 'control' && state?.counter === 0) {
      const obj = {
        location: state?.currLocation,
        subLocation: state?.currSubLocation,
        page: state?.currPage,
        control: locationValue,
      };
      clonedFormulaArray.push(obj);
      setState((prev) => ({ ...prev, counter: 1, currControl: locationValue, currentColumn: null, currentRow: -1 }));
    } else if (keyName === 'page' && state?.counter === 0) {
      setState((prev) => ({ ...prev, currPage: locationValue, currControl: null, currentColumn: null, currentRow: -1 }));
    } else if (keyName === 'subLocation' && state?.counter === 0 && isArray(locationValue?.name)) {
      if (state?.currLocation?.name !== 'Custom_Modules') {
        clonedFormulaArray = concat(clonedFormulaArray, locationValue?.name);
        setState((prev) => ({ ...prev, counter: 1, currSubLocation: locationValue }));
      } else {
        setState((prev) => ({ ...prev, currSubLocation: locationValue, currPage: null, currControl: null, currentRow: -1 }));
      }
    } else if (keyName === 'subLocation' && state?.counter === 0) {
      const obj = {
        location: state?.currLocation,
        subLocation: locationValue,
      };
      if (state?.currLocation?.name !== 'Custom_Modules') {
        clonedFormulaArray.push(obj);
        setState((prev) => ({ ...prev, counter: 1, currSubLocation: locationValue }));
      } else {
        setState((prev) => ({ ...prev, currSubLocation: locationValue, currPage: null, currControl: null, currentColumn: null, currentRow: -1 }));
      }
    } else if (['number', 'Number', 'Number_percentage'].includes(locationValue?.type)) {
      createAndPushObj(locationValue, clonedFormulaArray);
      setState((prev) => ({ ...prev, counter: 1, currSubLocation: null, currPage: null, currControl: null, currentColumn: null, currentRow: -1 }));
    } else if (keyName === 'calcSymbol' && (['(', ')', '%'].includes(locationValue?.name) || locationValue?.specialCondition)) {
      createAndPushObj(locationValue, clonedFormulaArray);
      if (['('].includes(locationValue?.name)) {
        setState((prev) => ({
          ...prev,
          bracketCounter: (prev?.bracketCounter || 0) + 1,
        }));
      }
      if (['π', '√', ')', 'X²'].includes(locationValue?.name)) {
        const stateObject = {
          counter: 1,
          currSubLocation: null,
          currPage: null,
          currControl: null,
          currentColumn: null,
          currentRow: -1,
        };
        if ([')'].includes(locationValue?.name)) {
          stateObject.bracketCounter = (state?.bracketCounter || 0) - 1;
        }
        setState((prev) => ({
          ...prev,
          ...stateObject,
        }));
      }
    } else if (keyName === 'calcSymbol' && state?.counter === 1) {
      createAndPushObj(locationValue, clonedFormulaArray);
      setState((prev) => ({ ...prev, counter: 0, currSubLocation: null, currPage: null, currControl: null, currentColumn: null, currentRow: -1 }));
    } else if (state?.counter === 0) {
      toasterMsg(t('CUSTOM_LIBRARY.CALCULATION_TYPE.SELECT_SUBlOCATION'), 'info');
    } else {
      toasterMsg(t('CUSTOM_LIBRARY.CALCULATION_TYPE.SELECT_SYMBOL'), 'info');
    }
    if (state?.currLocation?.name === 'Custom_Modules') {
      const foundCMFormulaString = clonedFormulaArray?.filter((val) =>
        val?.location?.name === 'Custom_Modules' ? customLibraryCase(val) : val?.control?.type === 'string',
      );
      const checkThisCMFormulaHasStringType = foundCMFormulaString?.length > 0;
      if (checkThisCMFormulaHasStringType) {
        clonedFormulaArray = hasStringValue(clonedFormulaArray);
      }
      updateFormulaString(clonedFormulaArray);
      setUndo([...undo, ...clonedFormulaArray]);
      setRedo([]);
    } else {
      const foundFormulaString = clonedFormulaArray?.filter((val) =>
        val?.location?.name === 'Custom_Modules' ? customLibraryCase(val) : val?.subLocation?.type === 'string',
      );
      const checkThisFormulaHasStringType = foundFormulaString?.length > 0;
      if (checkThisFormulaHasStringType) {
        clonedFormulaArray = clonedFormulaArray
          .filter((val) => !['(', ')', '%'].includes(val?.subLocation?.name))
          .map((eleFormula) => {
            let formula = eleFormula;
            if (formula?.subLocation?.type === 'symbol') {
              formula = {
                location: { name: '&', label: '&', type: 'symbol' },
                subLocation: { name: '&', label: '&', type: 'symbol' },
              };
            }
            return formula;
          });
      }
      updateFormulaString(clonedFormulaArray);
      setUndo([...undo, ...clonedFormulaArray]);
      setRedo([]);
    }
  };
  const converDropdownData = (allTypeData) => {
    const allData = cloneDeep(allTypeData);
    let filteredData = [];
    let filteredDropdownData = allData?.filter((ele) => ele?.type === 'dropdown' && ele?.isLable === true);
    const filteredTextData = allData?.filter((ele) => ele?.type === 'text' && ele?.isLable === false);
    if (!isEmpty(filteredDropdownData)) {
      filteredDropdownData = filteredDropdownData.map((item) => {
        const valuesForLabel = allData.filter((ele) => item._id === ele.lableId);
        item.options = valuesForLabel;
        return item;
      });
    }
    if (isArray(filteredDropdownData) && isArray(filteredTextData)) {
      filteredData = filteredDropdownData.concat(filteredTextData);
    }
    return filteredData;
  };

  const setSubLocationArr = () => {
    let subLocationArr = cloneDeep(calculationProductListSubLocationsArray?.find((val) => val?.locationId === state?.currLocation?._id) || {});
    if (state?.currLocation?._id === 10) {
      const options = customLibraryCalculationList?.map((ele) => ({
        label: ele?.moduleName,
        name: ele?._id,
        type: 'string',
      }));
      subLocationArr = { locationId: 10, subLocations: options };
    } else {
      let manipulatedDynamicColumns = converDropdownData(dynamicColArr);
      manipulatedDynamicColumns = manipulatedDynamicColumns?.map((dyCol) => {
        return {
          label: dyCol?.keyName,
          name: dyCol?._id,
          type: 'string',
        };
      });
      const manipulatedMeasurmentArr = measurementArr.map((dyCol) => {
        return {
          label: dyCol?.name,
          name: dyCol?._id,
          type: 'number',
        };
      });
      const sampleTrackingArr = sampleTrackingDates.map((dyCol) => {
        return {
          label: dyCol?.name,
          name: dyCol?._id,
          type: 'string',
        };
      });
      if (state?.currLocation?.name === 'Product_Information') {
        subLocationArr.subLocations = concat(subLocationArr?.subLocations, manipulatedDynamicColumns);
      }

      if (state?.currLocation?.name === 'Measurement_Information') {
        subLocationArr.subLocations = concat(subLocationArr?.subLocations, manipulatedMeasurmentArr);
      }
      if (state?.currLocation?.name === 'Sample_Information') {
        subLocationArr.subLocations = concat(subLocationArr?.subLocations, sampleTrackingArr);
      }
      if (checValidMongoId(state?.currLocation?.name)) {
        const getSectionsColumns = cloneDeep(currSectionList?.find((val) => val?._id === state?.currLocation?.name));
        const subLocationObj = {};
        if (getSectionsColumns && isArray(getSectionsColumns?.columns) && getSectionsColumns?.columns.length > 0) {
          const newSubColumns = getSectionsColumns?.columns?.map((dyCol) => {
            const obj = {
              label: dyCol?.title,
            };
            if (dyCol?.columnType === 'calculation') {
              obj.name = dyCol?.formulaArr;
              obj.type = 'number';
            } else if (dyCol?.columnType === 'source') {
              obj.name = [dyCol?.source];
              obj.type = 'number';
            } else if (dyCol?.columnType === 'manual') {
              obj.name = dyCol?._id;
              obj.type = 'manualNumber';
              obj.numberType = dyCol?.key;
            } else {
              console.error('dyCol=================', dyCol);
            }
            return obj;
          });

          subLocationObj.locationId = state?.currLocation?.name;
          subLocationObj.subLocations = newSubColumns;
        }

        subLocationArr = subLocationObj;
        return subLocationArr;
      }
    }
    return subLocationArr;
  };

  useMemo(() => {
    const subLocate = setSubLocationArr();
    setState((prev) => ({
      ...prev,
      filteredSubLocationArray: subLocate.subLocations || [],
      subLocationArray: subLocate.subLocations || [],
    }));
    return subLocate;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.currLocation?.name]);

  const setPageLocationArr = () => {
    let subLocationArr = {};
    if (state?.currLocation?._id === 10 && state?.currSubLocation) {
      const options = customLibraryPagesCalculationList?.map((ele) => ({
        label: ele?.pageTitle,
        name: ele?._id,
      }));
      subLocationArr = { ...subLocationArr, pages: options };
    }
    return subLocationArr;
  };

  useMemo(() => {
    const subLocate = setPageLocationArr();
    if (subLocate.pages) {
      setState((prev) => ({
        ...prev,
        pageArray: subLocate.pages || [],
        filteredPageArray: subLocate.pages || [],
      }));
    }
    return subLocate;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.currSubLocation?.name, customLibraryPagesCalculationList]);

  const setControlsLocationArr = () => {
    let subControlsArray = {};
    if (state?.currLocation?._id === 10 && state?.currSubLocation && state.currPage) {
      const options = customLibraryPageControlsCalculationList?.map((ele) => {
        return ele?.control?.key === 'Table'
          ? {
              label: ele?.control?.labelInModal || ele?.control?.label,
              name: ele?.i,
              type: 'Table',
              tableColumns: ele?.control?.tableColumns
                ?.filter((e) =>
                  ['Heading', 'Text_Area', 'Textbox', 'Dropdown', 'Ratio_Button', 'Number_Decimal', 'Number_Percentage', 'Calculation'].includes(e?.key),
                )
                ?.map((e) => ({
                  name: e?.fieldName,
                  key: e?.key,
                  type: ['Number_Decimal', 'Number_Percentage', 'Calculation'].includes(e?.key) ? 'number' : 'string',
                })),
              tableRows: ele?.control?.tableData?.map((e, i) => ({ name: i + 1, rowIndex: i + 1 })),
            }
          : {
              label: ele?.control?.label,
              name: ele?.i,
              type: ['Number', 'Number_Decimal', 'Number_Percentage', 'Calculation'].includes(ele?.control?.key) ? 'number' : 'string',
            };
      });
      subControlsArray = { ...subControlsArray, controls: options };
    }
    return subControlsArray;
  };

  useMemo(() => {
    const subLocate = setControlsLocationArr();
    setState((prev) => ({
      ...prev,
      controlsArray: subLocate.controls || [],
      filteredControlsArray: subLocate.controls || [],
    }));
    return subLocate;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.currPage?.name, customLibraryPageControlsCalculationList]);

  const clearLocation = (type) => {
    if (type === 'location') {
      if (customLibraryCalculationList?.length > 0) {
        action.clearCalculationList();
      }
      if (customLibraryPagesCalculationList?.length > 0) {
        action.clearCalculationPageList();
      }
      if (customLibraryPageControlsCalculationList?.length > 0) {
        action.clearCalculationControlList();
      }
      const subLocate = cloneDeep(calculationProductListSubLocationsArray?.find((val) => val?.locationId === productListLocationsArray?.[0]?._id) || {});
      setState((prev) => ({
        ...prev,
        currLocation: {
          label: productCoreInformation,
          name: 'Product_Core_Information',
          _id: 11,
        },
        filteredLocationArray: state?.locationArray,
        filteredSubLocationArray: subLocate?.subLocations,
        currSubLocation: null,
        currPage: null,
        currControl: null,
        filteredPageArray: [],
        pageArray: [],
        controlsArray: [],
        filteredControlsArray: [],
        currentColumn: null,
        currentRow: -1,
      }));
      locationRef.current.value = '';
    } else if (type === 'subLocation') {
      subLocationRef.current.value = '';
      if (customLibraryPagesCalculationList?.length > 0) {
        action.clearCalculationPageList();
      }
      if (customLibraryPageControlsCalculationList?.length > 0) {
        action.clearCalculationControlList();
      }
      setState((prev) => ({
        ...prev,
        filteredSubLocationArray: state?.subLocationArray,
        currPage: null,
        currControl: null,
        filteredPageArray: [],
        pageArray: [],
        controlsArray: [],
        filteredControlsArray: [],
        currentColumn: null,
        currentRow: -1,
      }));
    } else if (type === 'page') {
      if (customLibraryPageControlsCalculationList?.length > 0) {
        action.clearCalculationControlList();
      }
      pageRef.current.value = '';
      setState((prev) => ({
        ...prev,
        filteredPageArray: state?.pageArray,
        currControl: null,
        controlsArray: [],
        filteredControlsArray: [],
        currentColumn: null,
        currentRow: -1,
      }));
    } else {
      controlRef.current.value = '';
      setState((prev) => ({
        ...prev,
        filteredControlsArray: state?.controlsArray,
        currentColumn: null,
        currentRow: -1,
      }));
    }
  };

  const clearRefs = (ref) => {
    if (ref.current) {
      ref.current.value = '';
    }
  };

  const clearFormula = () => {
    clearRefs(locationRef);
    clearRefs(subLocationRef);
    clearRefs(pageRef);
    clearRefs(controlRef);
    setState((prev) => ({
      ...prev,
      formulaArray: [],
      formulaString: '',
      readOnlyFormulaString: '',
      counter: 0,
      currSubLocation: null,
      currPage: null,
      currControl: null,
      currLocation: {
        label: productCoreInformation,
        name: 'Product_Core_Information',
        _id: 11,
      },
      filteredLocationArray: state?.locationArray,
      filteredSubLocationArray: state?.subLocationArray,
      currentColumn: null,
      currentRow: -1,
    }));
    setUndo([]);
    setRedo([]);
  };

  const undoFormula = () => {
    const copyFormulaArr = cloneDeep(state?.formulaArray);
    if (Array.isArray(copyFormulaArr) && copyFormulaArr.length > 0) {
      const lastPopObject = copyFormulaArr.pop();
      const cloneRedoArr = [...(state?.redo || [])];
      if (lastPopObject) {
        cloneRedoArr.push(lastPopObject);
      }
      const getObj = copyFormulaArr[copyFormulaArr.length - 1];
      let counter = state?.counter || 0;
      if (getObj?.subLocation?.type === 'symbol' || !getObj) {
        counter = 0;
      } else if (getObj) {
        counter = 1;
      }
      setRedo([...redo, ...cloneRedoArr]);
      setUndo(copyFormulaArr);
      updateFormulaString(copyFormulaArr);
      setState((prev) => ({ ...prev, currSubLocation: null, counter, currPage: null, currControl: null, currentColumn: null, currentRow: -1 }));
    }
  };

  const redoFormula = () => {
    let cloneRedo = [...(redo || [])];
    const copyFormulaArr = cloneDeep(state?.formulaArray || []);
    if (cloneRedo.length > 0) {
      copyFormulaArr.push(cloneRedo.pop());
      cloneRedo = redo.slice(0, -1);
    }
    const getObj = copyFormulaArr[copyFormulaArr.length - 1];
    let counter = state?.counter || 0;
    if (getObj?.subLocation?.type === 'symbol') {
      counter = 0;
    } else if (getObj) {
      counter = 1;
    }
    setRedo(cloneRedo);
    setUndo([...undo, ...cloneRedo]);
    updateFormulaString(copyFormulaArr);
    setState((prev) => ({ ...prev, currSubLocation: null, counter, currPage: null, currControl: null, currentColumn: null, currentRow: -1 }));
  };

  const valiDateState = async () => {
    let isValid = true;
    if (
      !state?.name?.trim().length ||
      state?.formulaArray.length === 0 ||
      (last(state?.formulaArray)?.subLocation?.label === '²' && state?.formulaArray.length === 1) ||
      (last(state?.formulaArray)?.subLocation?.type === 'symbol' && ![')', '%', 'π', '²'].includes(last(state?.formulaArray)?.subLocation?.label)) ||
      state?.bracketCounter !== 0
    ) {
      if (last(state?.formulaArray)?.subLocation?.name === '√') {
        setRootAtLast(true);
      } else if (state?.name?.trim().length > 0 && state?.formulaArray.length > 0) {
        setFormulaHasError(true);
      }
      isValid = false;
    }
    return isValid;
  };

  const createCustomModal = async () => {
    const isValid = await valiDateState();
    if (isValid) {
      if (customModuleState?.modalEdit) {
        setIsEditCalculation(true);
        const relationObject = {};
        const keysNeeded = ['formulaArray', 'formulaString', 'readOnlyFormulaString'];
        keysNeeded.forEach((key) => {
          if (state[key] !== null) {
            relationObject[key] = state[key];
          }
        });
        onChange({ relation: relationObject, label: state?.name }, 'relation', customModuleState?.editPopupGridIndex, customModuleState?.editPopupPageIndex);
      } else {
        setIsCalculation(false);
        const relationObject = {};
        const keysNeeded = ['formulaArray', 'formulaString', 'readOnlyFormulaString'];
        keysNeeded.forEach((key) => {
          if (state[key] !== null) {
            relationObject[key] = state[key];
          }
        });
        onChange({ relation: relationObject, label: state?.name }, 'relation', gridIndex, pageIndex);
      }
      setCustomModuleState((prevState) => ({
        ...prevState,
        modalEdit: false,
        editPopupGridInd: -1,
        editPopupPageIndex: -1,
        editpopupChildData: null,
        editPopup: false,
        disableDrag: false,
        locationArray: [],
        filteredLocationArray: [],
      }));
    } else {
      setState((prevState) => ({ ...prevState, hasError: true }));
    }
    dispatch(rangePlaneAction.clearSectionList());
  };

  const closeCalculationModal = () => {
    if (moduleLibId) {
      setIsEditCalculation(false);
      if (!customLibraryDetail?.pages?.[pageIndex]?.grid?.[gridIndex]?.control?.relation) {
        deleteItem(gridIndex, pageIndex, true);
      }
    } else {
      setIsCalculation(false);
      if (!customLibraryDetail?.pages?.[pageIndex]?.grid?.[gridIndex]?.control?.relation) {
        deleteItem(gridIndex, pageIndex);
      }
    }
    setDroppedIndex(-1);
    setCustomModuleState((prevState) => ({
      ...prevState,
      modalEdit: false,
      editPopupGridInd: -1,
      editPopupPageIndex: -1,
      editpopupChildData: null,
      editPopup: false,
      disableDrag: false,
      locationArray: [],
      filteredLocationArray: [],
      subLocationArray: [],
      filteredSubLocationArray: [],
      pageArray: [],
      filteredPageArray: [],
      controlsArray: [],
      filteredControlsArray: [],
    }));
    dispatch(action.clearCalculationList());
    dispatch(rangePlaneAction.clearSectionList());
  };

  const fadingStyle = () => {
    return !counterState && !['(', '√', 'X²', 'π'].includes(last(state?.formulaArray)?.subLocation?.name) ? 'disabled' : '';
  };

  const createNewSubColumns = () => {
    const getSectionsColumns = flatMap(cloneDeep(currSectionList?.map((dyCol) => dyCol?.columns)));
    return getSectionsColumns?.map((dyCol) => {
      const obj = {
        label: dyCol?.title,
      };
      if (dyCol?.columnType === 'calculation') {
        obj.name = dyCol?.formulaArr;
        obj.type = 'number';
      } else if (dyCol?.columnType === 'source') {
        obj.name = [dyCol?.source];
        obj.type = 'number';
      } else if (dyCol?.columnType === 'manual') {
        obj.name = dyCol?._id;
        obj.type = 'manualNumber';
        obj.numberType = dyCol?.key;
      }
      return obj;
    });
  };

  // this isfunction to create a new Formula array based on readonly string formula.
  //  ensure that the ladder stays in the respective order for proper value rendering.
  const handleResultValue = (result, newFormulaArray) => {
    let hasError = false;
    result?.forEach((ele) => {
      const characters = calculationBtnArr?.find((val) => (val?.specialCondition ? val?.label === ele : val?.name === ele));
      const relation = state?.filteredSubLocationArray?.find((val) => val?.label === ele);
      const subLocationValue = handleSubLocation(ele);
      const newSubColumns = createNewSubColumns();
      const foundSubColumn = newSubColumns?.find((val) => val?.label === ele);
      if (characters) {
        newFormulaArray.push({ location: characters, subLocation: characters });
      } else if (relation) {
        newFormulaArray.push({ location: relation, subLocation: relation });
      } else if (subLocationValue) {
        newFormulaArray.push(subLocationValue);
      } else if (parseFloat(ele)) {
        const splitDigits = parseFloat(ele)?.toString()?.split('');
        if (splitDigits?.length > 0) {
          hasError = handleResultValue(splitDigits, newFormulaArray);
        }
      } else if (foundSubColumn) {
        newFormulaArray.push(...(foundSubColumn?.name || []));
      } else {
        hasError = true;
      }
    });
    return hasError;
  };

  const handleNewFormulaArray = (newFormulaArray) => {
    const hasString = newFormulaArray?.find((val) => val?.subLocation?.type === 'string');
    let finalNewFormulaArray = newFormulaArray;
    if (hasString) {
      const filteredArr = newFormulaArray?.filter((val) => !['(', ')', '%'].includes(val?.subLocation?.name));
      finalNewFormulaArray = filteredArr?.map((formulaELe) => {
        if (['+', '-', '*', '/', 'π', '²', '√'].includes(formulaELe?.subLocation?.name)) {
          return {
            location: { name: '&', label: '&', type: 'symbol' },
            subLocation: { name: '&', label: '&', type: 'symbol' },
          };
        }
        return formulaELe;
      });
    }
    updateFormulaString(finalNewFormulaArray);
  };

  const handleEditClick = () => {
    if (allowEditFormula) {
      if (state?.readOnlyFormulaString?.length > 0) {
        const result = splitAndFilterString(state?.readOnlyFormulaString);
        let hasError = false;
        const newFormulaArray = [];
        if (result.length > 0) {
          hasError = handleResultValue(result, newFormulaArray);
        }
        if (hasError) {
          setFormulaHasError(true);
          return;
        }
        if (newFormulaArray.length > 0) {
          handleNewFormulaArray(newFormulaArray);
        }
        setFormulaHasError(false);
      } else {
        setFormulaHasError(true);
        return;
      }
    }
    setAllowEditFormula(!allowEditFormula);
  };

  const handleFormulaDirectly = (value) => {
    const string = value?.replace(/\s*\[(.*?)_.*?\]/g, '$1');
    setState((prev) => ({ ...prev, readOnlyFormulaString: string }));
  };
  return (
    <Modal className="common-custom-modal calculation-modal modal-large" show={showEdit}>
      <Modal.Header>
        <Modal.Title>{t('CUSTOM_LIBRARY.CALCULATION_TYPE.CREATE_RELATION')}</Modal.Title>
        <CloseIcon size={24} className="cursor-pointer" onClick={closeCalculationModal} />
      </Modal.Header>
      <Modal.Body>
        {state?.mainLoader ? (
          <Loader />
        ) : (
          <div key={`calculation_${gridIndex}_${pageIndex}_${index}`}>
            <FormGroup className="mb-0 formula-expression-section">
              <div className="card common-listing-card common-calculation-card">
                <div className="card-header py-2 px-3">{t('CUSTOM_LIBRARY.CALCULATION_TYPE.FORMULA_EXPRESSION')}</div>
                <div className="card-body p-2 d-flex position-relative">
                  {allowEditFormula ? (
                    <MentionsInput
                      value={state?.readOnlyFormulaString}
                      onChange={(e) => handleFormulaDirectly(e?.target?.value)}
                      placeholder={t('CUSTOM_MODULES.LIBRARY.TEMPLATE_COLUMN.NEW_CONTROL.CALCULATION_COMPONENET.READONLY_FORMULA_PLACEHOLDER')}
                      className="form-control "
                    >
                      <Mention
                        markup="[__display__]"
                        trigger="@"
                        data={childOptions}
                        displayTransform={(id, display) => display.split('_(')[0]}
                        renderSuggestion={(suggestion, search, highlightedDisplay) => <div className="user">{highlightedDisplay}</div>}
                      />
                    </MentionsInput>
                  ) : (
                    <NewTextArea
                      placeholder={t('CUSTOM_MODULES.LIBRARY.TEMPLATE_COLUMN.NEW_CONTROL.CALCULATION_COMPONENET.CREATED_FORMULA')}
                      value={state?.readOnlyFormulaString}
                      onChange={(e) => handleFormulaDirectly(e?.target?.value)}
                      readOnly={!allowEditFormula}
                    />
                  )}
                  {!hideCustomModule && (
                    <button
                      type="button"
                      className="ml-auto btn  p-0 position-absolute placement-top-right"
                      onClick={handleEditClick}
                      aria-label="Edit Formula"
                    >
                      {allowEditFormula ? <SaveIcon size={24} /> : <EditIcon size={24} />}
                    </button>
                  )}
                </div>
              </div>
              {formulaHasError && <span className="error-message text-center">{t('CUSTOM_LIBRARY.CALCULATION_TYPE.INVALID_FORMULA')}</span>}
              {rootAtLast && <span className="error-message text-center">{t('CUSTOM_LIBRARY.CALCULATION_TYPE.ROOT_AT_LAST')}</span>}
              {state?.hasError && !state?.formulaArray.length && !formulaHasError && (
                <span className="error-message text-center">{t('CUSTOM_LIBRARY.CALCULATION_TYPE.FORMULA_MISSING')}</span>
              )}
            </FormGroup>
            <div className="d-flex formula-btns">
              <button type="button" className="btn btn-outline" onClick={clearFormula} disabled={allowEditFormula} aria-label="clear">
                <ClearIcon size={24} />
              </button>
              {calculationBtnArr?.map((sym) => {
                return (
                  <button
                    key={sym}
                    className={`btn btn-outline ${sym.className}`}
                    onClick={() => {
                      onLocationChange(sym, 'calcSymbol');
                    }}
                    type="button"
                    disabled={(sym.type !== 'number' && sym?.disabled) || allowEditFormula}
                  >
                    {sym?.name}
                  </button>
                );
              })}

              <button
                type="button"
                className="btn btn-outline"
                onClick={undoFormula}
                disabled={(isArray(undo) && undo.length <= 0) || allowEditFormula}
                aria-label="undo"
              >
                <UndoIcon size={24} />
              </button>
              <button
                type="button"
                className="btn btn-outline"
                onClick={redoFormula}
                disabled={(isArray(redo) && !redo.length > 0) || allowEditFormula}
                aria-label="Redo"
              >
                <RedoIcon size={24} />
              </button>
            </div>
            <Row>
              <Col>
                <div className="card common-listing-card common-calculation-card ">
                  <div className="card-header f-16 d-flex align-items-center ">{t('CUSTOM_LIBRARY.SOURCE_TYPE.LOCATION')}</div>
                  <div className="card-body p-0">
                    <div className="calc-filter-container d-flex align-items-center">
                      <SearchIcon size={24} />
                      <NewInput
                        type="text"
                        className="border-none"
                        ref={locationRef}
                        disabled={allowEditFormula || checkFormulaHasPercentageAtLast.disableNumbers}
                        onChange={(e) => handleFilter(e.target.value, 'location')}
                        placeholder={t('COMMON_LABEL.SEARCH')}
                      />
                      <button
                        type="button"
                        onClick={() => clearLocation('location')}
                        aria-label="Clear Location"
                        disabled={allowEditFormula || checkFormulaHasPercentageAtLast.disableNumbers}
                        className="btn p-0 border-none bg-transparent"
                      >
                        <CloseIcon size={24} />
                      </button>
                    </div>

                    <ul className="location-ul">
                      {state?.filteredLocationArray?.map((loca) => {
                        return (
                          <li key={loca?._id} className={state?.currLocation?.name === loca?.name && counterState ? 'active' : fadingStyle()}>
                            <button
                              type="button"
                              className="btn p-0"
                              onClick={() => onLocationChange(loca, 'location')}
                              disabled={allowEditFormula || checkFormulaHasPercentageAtLast.disableNumbers}
                            >
                              {loca?.label}
                            </button>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              </Col>
              <Col>
                <div className="card common-listing-card common-calculation-card ">
                  <div className="card-header py-1  f-16  d-flex align-items-center ">{t('CUSTOM_LIBRARY.SOURCE_TYPE.SUB_LOCATION')}</div>
                  <div className="card-body p-0">
                    <div className="calc-filter-container d-flex align-items-center">
                      <SearchIcon size={24} />
                      <NewInput
                        type="text"
                        className="border-none"
                        ref={subLocationRef}
                        disabled={allowEditFormula || checkFormulaHasPercentageAtLast.disableNumbers}
                        onChange={(e) => handleFilter(e.target.value, 'subLocation')}
                        placeholder={t('COMMON_LABEL.SEARCH')}
                      />
                      <button
                        type="button"
                        onClick={() => clearLocation('subLocation')}
                        aria-label="Clear SubLocation"
                        disabled={allowEditFormula || checkFormulaHasPercentageAtLast.disableNumbers}
                        className="btn p-0 border-none bg-transparent"
                      >
                        <CloseIcon size={24} />
                      </button>
                    </div>
                    <ul className="location-ul">
                      {state?.filteredSubLocationArray?.map((subLoc) => {
                        return (
                          <li key={subLoc?._id} className={state?.currSubLocation?.name === subLoc?.name && counterState ? 'active' : fadingStyle()}>
                            <button
                              type="button"
                              className="btn p-0"
                              onClick={() => onLocationChange(subLoc, 'subLocation')}
                              disabled={!counterState || allowEditFormula || checkFormulaHasPercentageAtLast.disableNumbers}
                            >
                              {subLoc?.label}
                            </button>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              </Col>
              {state?.currLocation?.name === 'Custom_Modules' && state?.currSubLocation && (
                <Col>
                  <div className="card common-listing-card common-calculation-card">
                    <div className="card-header py-1 f-16  d-flex align-items-center ">
                      {t('CUSTOM_MODULES.LIBRARY.TEMPLATE_COLUMN.NEW_CONTROL.CALCULATION_COMPONENET.PAGE')}
                    </div>
                    <div className="card-body p-0">
                      <div className="calc-filter-container d-flex  align-items-center">
                        <SearchIcon size={24} />
                        <NewInput
                          type="text"
                          className="border-none"
                          ref={pageRef}
                          disabled={allowEditFormula || checkFormulaHasPercentageAtLast.disableNumbers}
                          onChange={(e) => handleFilter(e.target.value, 'page')}
                          placeholder={t('COMMON_LABEL.SEARCH')}
                        />
                        <button
                          type="button"
                          onClick={() => clearLocation('page')}
                          aria-label="Clear Location"
                          disabled={allowEditFormula || checkFormulaHasPercentageAtLast.disableNumbers}
                          className="btn p-0 border-none bg-transparent"
                        >
                          <CloseIcon size={24} />
                        </button>
                      </div>

                      <ul className="location-ul">
                        {state?.filteredPageArray?.map((loca) => {
                          return (
                            <li key={loca?.name} className={state?.currPage?.name === loca?.name && counterState ? 'active' : fadingStyle()}>
                              <button
                                type="button"
                                className="btn p-0"
                                onClick={() => onLocationChange(loca, 'page')}
                                disabled={allowEditFormula || checkFormulaHasPercentageAtLast.disableNumbers}
                              >
                                {loca?.label}
                              </button>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                </Col>
              )}
              {state?.currLocation?.name === 'Custom_Modules' && state?.currSubLocation && state?.currPage && (
                <Col>
                  <div className="card common-listing-card common-calculation-card ">
                    <div className="card-header py-1 f-16  d-flex align-items-center ">{t('CUSTOM_LIBRARY.SOURCE_TYPE.CONTROLS')}</div>
                    <div className="card-body p-0">
                      <div className="calc-filter-container d-flex align-items-center">
                        <SearchIcon size={24} />
                        <NewInput
                          type="text"
                          className="border-none"
                          ref={controlRef}
                          disabled={allowEditFormula || checkFormulaHasPercentageAtLast.disableNumbers}
                          onChange={(e) => handleFilter(e.target.value, 'control')}
                          placeholder={t('COMMON_LABEL.SEARCH')}
                        />
                        <button
                          type="button"
                          onClick={() => clearLocation('control')}
                          aria-label="Clear SubLocation"
                          disabled={allowEditFormula || checkFormulaHasPercentageAtLast.disableNumbers}
                          className="btn p-0 border-none bg-transparent"
                        >
                          <CloseIcon size={24} />
                        </button>
                      </div>
                      <ul className="location-ul">
                        {state?.filteredControlsArray?.map((ctrl) => {
                          return (
                            <li key={ctrl?.name} className={state?.currControl?.name === ctrl?.name && counterState ? 'active' : fadingStyle()}>
                              <button
                                type="button"
                                disabled={!counterState || allowEditFormula || checkFormulaHasPercentageAtLast.disableNumbers}
                                className="btn p-0"
                                onClick={() => onLocationChange(ctrl, 'control')}
                              >
                                {ctrl?.label}
                              </button>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                </Col>
              )}
              {state?.currLocation?.name === 'Custom_Modules' && state?.currSubLocation && state?.currPage && state?.currControl?.type === 'Table' && (
                <Col>
                  <div className="card common-listing-card common-calculation-card ">
                    <div className="card-header py-1 f-16  d-flex align-items-center ">{t('CUSTOM_LIBRARY.SOURCE_TYPE.TABLE')}</div>
                    <div className="card-body p-0">
                      <Select
                        className="common-react-select"
                        options={state?.currControl?.tableColumns}
                        menuPlacement="top"
                        getOptionLabel={(option) => `${option.name}`}
                        getOptionValue={(option) => `${option.key}`}
                        name="Column"
                        value={state?.currentColumn}
                        styles={customStyles}
                        isDisabled={!counterState || allowEditFormula || checkFormulaHasPercentageAtLast.disableNumbers}
                        placeholder={t('CUSTOM_LIBRARY.SOURCE_TYPE.TABLE_COLUMN_PLACEHOLDER')}
                        onChange={(e) => onLocationChange(e, 'currentColumn')}
                      />
                      <Select
                        className="common-react-select"
                        options={state?.currControl?.tableRows}
                        menuPlacement="top"
                        getOptionLabel={(option) => `${option.name}`}
                        getOptionValue={(option) => `${option.rowIndex}`}
                        name="Row"
                        value={state?.currentRow}
                        styles={customStyles}
                        isDisabled={!counterState || allowEditFormula || checkFormulaHasPercentageAtLast.disableNumbers}
                        placeholder={t('CUSTOM_LIBRARY.SOURCE_TYPE.TABLE_ROW_PLACEHOLDER')}
                        onChange={(e) => onLocationChange(e, 'currentRow')}
                      />
                    </div>
                  </div>
                </Col>
              )}
            </Row>
            <div className="input-group form-floating-label fixed-label mt-16">
              <NewInput
                type="text"
                name="ColumnName"
                placeholder={t('CUSTOM_MODULES.LIBRARY.TEMPLATE_COLUMN.NEW_CONTROL.CALCULATION_COMPONENET.ENTER_COLUMN')}
                className="f-14"
                maxLength={30}
                value={state?.name}
                onChange={(e) => onLocationChange(e?.target?.value, 'name')}
              />
              <label className="asterisk-req f-16 mb-0">
                {t('CUSTOM_LIBRARY.SOURCE_TYPE.COLUMN_TITLE')} <span>*</span>
              </label>
            </div>
            {state?.hasError && !state?.name?.trim().length && (
              <span className="error-message text-center">{t('CUSTOM_LIBRARY.CALCULATION_TYPE.COLUMN_TITLE_MISSING')}</span>
            )}
          </div>
        )}
        <div className="common-model-footer mt-16">
          <button type="button" className="btn p-0" onClick={createCustomModal} disabled={allowEditFormula} aria-label="save">
            <TickIcon size={24} />
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
